import {
  fetchLatestHouseImagesFilter,
  fetchLatestHouseImages,
} from "@/store/slices/GlobalSlice";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./style.scss";

const btnAll = { name: "All", id: 1, description: "", image_url: "" };

const TownGalleryFilterBar = (props) => {
  const dispatch = useDispatch();
  const [currentActive, setCurrentActive] = useState("All");
  const { mainCategories } = useSelector((state) => state.globalSlice);
  const filterButtons = [...mainCategories, btnAll];

  const handleFilterButton = (button) => {
    if (button.name === "All") {
      dispatch(fetchLatestHouseImages());
      setCurrentActive(button.name);
      return;
    }

    dispatch(fetchLatestHouseImagesFilter(button.id));
    setCurrentActive(button.name);
  };

  return (
    <div className="flex flex-col md:flex-row items-center justify-center md:space-x-5 mb-6 md:mb-4">
      <span className="text-28 font-semibold text-sgbc-black-800 mb-3 md:mb-0">
        Greens Means Go
      </span>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4">
        {filterButtons?.map((button) => (
          <span
            key={button.id}
            onClick={() => handleFilterButton(button)}
            className={`group block md:inline-block bg-white rounded-full hover:bg-sgbc-green-500 text-sgbc-black-800 hover:text-white py-1 px-5 text-lg transition-all duration-200 ease-in-out font-semibold cursor-pointer text-center ${
              currentActive === button.name ? "btn--active-filter" : ""
            }`}
          >
            <span className="group-focus:text-yellow-300">{button.name}</span>
          </span>
        ))}
      </div>
    </div>
  );
};

TownGalleryFilterBar.propTypes = {};

export default TownGalleryFilterBar;
